import _createClass from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workspaces/neuler/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { EventDispatcher, Matrix4, Plane, Raycaster, Vector2, Vector3 } from 'three';
var _plane = new Plane();
var _raycaster = new Raycaster();
var _pointer = new Vector2();
var _offset = new Vector3();
var _intersection = new Vector3();
var _worldPosition = new Vector3();
var _inverseMatrix = new Matrix4();
var DragControls = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(DragControls, _EventDispatcher);
  var _super = _createSuper(DragControls);
  function DragControls(_objects, _camera, _domElement) {
    var _this;
    _classCallCheck(this, DragControls);
    _this = _super.call(this);
    _domElement.style.touchAction = 'none'; // disable touch scroll

    var _selected = null,
      _hovered = null;
    var _intersections = [];

    //

    var scope = _assertThisInitialized(_this);
    function activate() {
      _domElement.addEventListener('pointermove', onPointerMove);
      _domElement.addEventListener('pointerdown', onPointerDown);
      _domElement.addEventListener('pointerup', onPointerCancel);
      _domElement.addEventListener('pointerleave', onPointerCancel);
    }
    function deactivate() {
      _domElement.removeEventListener('pointermove', onPointerMove);
      _domElement.removeEventListener('pointerdown', onPointerDown);
      _domElement.removeEventListener('pointerup', onPointerCancel);
      _domElement.removeEventListener('pointerleave', onPointerCancel);
      _domElement.style.cursor = '';
    }
    function dispose() {
      deactivate();
    }
    function getObjects() {
      return _objects;
    }
    function getRaycaster() {
      return _raycaster;
    }
    function onPointerMove(event) {
      if (scope.enabled === false) return;
      updatePointer(event);
      _raycaster.setFromCamera(_pointer, _camera);
      if (_selected) {
        if (_raycaster.ray.intersectPlane(_plane, _intersection)) {
          _selected.position.copy(_intersection.sub(_offset).applyMatrix4(_inverseMatrix));
        }
        scope.dispatchEvent({
          type: 'drag',
          object: _selected
        });
        return;
      }

      // hover support

      if (event.pointerType === 'mouse' || event.pointerType === 'pen') {
        _intersections.length = 0;
        _raycaster.setFromCamera(_pointer, _camera);
        _raycaster.intersectObjects(_objects, true, _intersections);
        if (_intersections.length > 0) {
          var object = _intersections[0].object;
          _plane.setFromNormalAndCoplanarPoint(_camera.getWorldDirection(_plane.normal), _worldPosition.setFromMatrixPosition(object.matrixWorld));
          if (_hovered !== object && _hovered !== null) {
            scope.dispatchEvent({
              type: 'hoveroff',
              object: _hovered
            });
            _domElement.style.cursor = 'auto';
            _hovered = null;
          }
          if (_hovered !== object) {
            scope.dispatchEvent({
              type: 'hoveron',
              object: object
            });
            _domElement.style.cursor = 'pointer';
            _hovered = object;
          }
        } else {
          if (_hovered !== null) {
            scope.dispatchEvent({
              type: 'hoveroff',
              object: _hovered
            });
            _domElement.style.cursor = 'auto';
            _hovered = null;
          }
        }
      }
    }
    function onPointerDown(event) {
      if (scope.enabled === false) return;
      updatePointer(event);
      _intersections.length = 0;
      _raycaster.setFromCamera(_pointer, _camera);
      _raycaster.intersectObjects(_objects, true, _intersections);
      if (_intersections.length > 0) {
        _selected = scope.transformGroup === true ? _objects[0] : _intersections[0].object;
        _plane.setFromNormalAndCoplanarPoint(_camera.getWorldDirection(_plane.normal), _worldPosition.setFromMatrixPosition(_selected.matrixWorld));
        if (_raycaster.ray.intersectPlane(_plane, _intersection)) {
          _inverseMatrix.copy(_selected.parent.matrixWorld).invert();
          _offset.copy(_intersection).sub(_worldPosition.setFromMatrixPosition(_selected.matrixWorld));
        }
        _domElement.style.cursor = 'move';
        scope.dispatchEvent({
          type: 'dragstart',
          object: _selected
        });
      }
    }
    function onPointerCancel() {
      if (scope.enabled === false) return;
      if (_selected) {
        scope.dispatchEvent({
          type: 'dragend',
          object: _selected
        });
        _selected = null;
      }
      _domElement.style.cursor = _hovered ? 'pointer' : 'auto';
    }
    function updatePointer(event) {
      var rect = _domElement.getBoundingClientRect();
      _pointer.x = (event.clientX - rect.left) / rect.width * 2 - 1;
      _pointer.y = -(event.clientY - rect.top) / rect.height * 2 + 1;
    }
    activate();

    // API

    _this.enabled = true;
    _this.transformGroup = false;
    _this.activate = activate;
    _this.deactivate = deactivate;
    _this.dispose = dispose;
    _this.getObjects = getObjects;
    _this.getRaycaster = getRaycaster;
    return _this;
  }
  return _createClass(DragControls);
}(EventDispatcher);
export { DragControls };